import axios from "../axios";

/**
 * 保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/mCd/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

/**
 * 列表查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findPage = (data) => {
  return axios({
    url: '/mCd/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

export const del = (data) => {
  return axios({
    url: '/mCd/delete',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

//下载模板

export const download = (data) => {
  return axios({
    url: '/mCd/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
//导出

export const exportCdgl = (data, name) => {
  return axios({
    url: '/mCd/export',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}

export const queryKhd = (data) => {
  return axios({
    url: '/mCd/queryKhd',
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/http/moudules/cdgl.js